import { useLocation } from "react-router-dom";
import { store } from "@/services/store";
import { useCart } from "@/context/CartContext";

export default function WhatsAppButton() {
  const { isOpen } = useCart();
  const { pathname } = useLocation();
  // Fica escondido com a sacola aberta e na administração.
  if (isOpen || pathname.startsWith("/admin")) return null;
  return (
    <a className="bz-whatsapp" href={store.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="Fale com a Bozzetti Store pelo WhatsApp">
      <i className="ri-whatsapp-line" aria-hidden="true"></i>
    </a>
  );
}
